(function () {
    'use strict';
    /**
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * @ngdoc service
     * @name ihh-common-web.RxExUtilities
     * @requires {Object} RestResources
     * @requires {Object} QuantityTypeConstants
     * @requires {Object} appConfig
     *
     * @description
     *  This service provides utilities useful for the prescription exercise functionality,
     *  specifically related to prescription and protocol pages.
     */
    angular
        .module('ihh-common-web')
        .factory('RxExUtilities', RxExUtilities);

    RxExUtilities.$inject = ['RestResources', 'QuantityTypeConstants', 'AppConfigSvc'];

    function RxExUtilities(RestResources, QuantityTypeConstants, AppConfigSvc) {
        var repetitions = QuantityTypeConstants.repetitions;
        var duration = QuantityTypeConstants.duration;
        var defaultState = 'None';

        /**
         * This function returns the valid quantity types
         * @returns {Array} the QuantityTypes
         */
        function getQuantityTypes () {
            return [repetitions, duration];
        }

        /**
         * This function returns the quantity type from the template
         * @param {Object} exerciseTemplate
         * @returns {String} the quantity type
         */
        function getQuantityType (exerciseTemplate) {
            return exerciseTemplate.quantityType;
        }

        /**
         * This function sets the quantity type
         * @param {String} state the desired quantity type
         * @param {Object} exerciseTemplate the template to set the quantity type on
         * @param {Object} form the form that is present
         */
        function setQuantityType (state, exerciseTemplate, form) {
            if (state === repetitions) {
                exerciseTemplate.quantityType = repetitions;
                form.$setDirty();
            }
            else if (state === duration) {
                exerciseTemplate.quantityType = duration;
                form.$setDirty();
            }
        }

        /**
         * This function returns the resistance item value that is set on an template
         * @param {Object} exerciseTemplate
         * @returns {String} the resistance item value or the default string
         */
        function getResistanceItemValue (exerciseTemplate) {
            if (exerciseTemplate.resistanceItemValue) {
                return exerciseTemplate.resistanceItemValue;
            }
            else if (exerciseTemplate.exercise.resistanceItemValue) {
                return exerciseTemplate.exercise.resistanceItemValue;
            }
            else {
                return defaultState;
            }
        }

        /**
         * This function sets the resistance item value on the provided template
         * @param {String} state the resistance item value
         * @param {Object} exerciseTemplate the template to set the resistance value on
         * @param {Object} form the form that is present
         */
        function setResistanceItemValue (state, exerciseTemplate, form) {
            if (angular.isDefined(exerciseTemplate.resistanceItemValue) && defaultState === state) {
                delete exerciseTemplate.resistanceItemValue;
                form.$setDirty();
            }
            else if ((angular.isUndefined(exerciseTemplate.resistanceItemValue) && defaultState !== state) || (angular.isDefined(exerciseTemplate.resistanceItemValue) && exerciseTemplate.resistanceItemValue !== state)) {
                exerciseTemplate.resistanceItemValue = state;
                form.$setDirty();
            }
        }

        /**
         * This function returns an exercise link url
         * note: this will need to be generalized with the addition of admin app uses
         * @param {Object} exerciseTemplate the template to use for link creation
         * @param {Boolean} isEdit used to determine if the app is in edit mode
         * @returns {String} the exercise link url
         */
        function getExerciseLinkUrl(exerciseTemplate, isEdit) {
            if (!isEdit) {
                var route = AppConfigSvc.getExerciseLinkRoute();

                if (route !== null && angular.isDefined(exerciseTemplate.exercise)) {
                    return route + exerciseTemplate.exercise.id;
                }
            }

            return null;
        }

        /**
         * This function gets the exercise thumbnail url
         * @param {Object} exerciseTemplate the template to use for link creation
         * @returns {String} the exercise thumbnail url
         */
        function getExerciseThumbnailUrl(exerciseTemplate) {
            return RestResources.getExerciseThumbnailUrl(exerciseTemplate);
        }

        return {
            getQuantityTypes: getQuantityTypes,
            getQuantityType: getQuantityType,
            setQuantityType: setQuantityType,
            getResistanceItemValue: getResistanceItemValue,
            setResistanceItemValue: setResistanceItemValue,
            getExerciseLinkUrl: getExerciseLinkUrl,
            getExerciseThumbnailUrl: getExerciseThumbnailUrl
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('ihh-common-web')
        .constant('QuantityTypeConstants', {
            repetitions: 'Repetitions',
            duration: 'Duration'
        });
})();